const modelsAccepted = { user: 'users', store: 'stores', userType: 'usersTypes' }

export { modelsAccepted }
